<template>
  <div id="app-switch">

    <div>


      <div class="panel-login">
        <!--<h1>Choose a client</h1>-->

          <div class="wrapper">

            <ul :class="$store.getters.user.scopes.length > 5 ? 'collapsed' : ''">
              <li v-for="item in $store.getters.user.scopes" :value="item.slug" @click="choose(item.slug)">

                <div class="parent-logo" v-bind:style="{background:$store.getters.scopes[item.parent_id].color}" v-if="item.parent_id && $store.getters.scopes[item.parent_id]">
                  <img :src="$store.getters.scopes[item.parent_id].picture.url+'/fit/100x100'" v-if="$store.getters.scopes[item.parent_id].picture">
                  <span v-if="!$store.getters.scopes[item.parent_id].picture">{{ $store.getters.scopes[item.parent_id].slug.substr(0,1) }}</span>
                </div>

                <div class="logo-scope" v-bind:style="{background:item.color}" xv-if="!item.picture">
                  <span>{{ item.slug.substr(0,1) }}</span>
                </div>

                <span class="name">{{ item.name }}</span>
              </li>
            </ul>

        </div>

      </div>


    </div>

  </div>
</template>

<script>
    export default {
        name: 'switch-scope',
        data() {
            return {
            }
        },
        mounted: function(){

        },
        methods: {
            choose(slug) {
                this.$store.dispatch("switchScope", slug).then(() => {
                    this.$router.push("/dashboard")
                });
            }
        }
    }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Switch.vue